import { ReleaseFlagProvider, UserProvider } from '@libs/contexts';
import { ErrorPageTmpl } from '@libs/templates/template-pages/templates';
import { DeleteDialogProvider, GuideTabProvider } from '@ps-smart-cp/ppfw-client';
import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router';

function SuspenseFallback() {
  const { pathname } = useLocation();
  const subsystem = pathname.split('/')[1];
  const homePath = subsystem === 'system-management' ? '/system-management/main-menu' : 'fa/main-menu';

  return (
    <ErrorPageTmpl title="ページ更新中" homePath={homePath}>
      新しいページを読み込んでいます...
      <br />
      <br />
      しばらくお待ちください。
      <br />
      <br />
    </ErrorPageTmpl>
  );
}

function AppContainer() {
  return (
    <DeleteDialogProvider>
      <GuideTabProvider>
        <UserProvider>
          <ReleaseFlagProvider>
            <Suspense fallback={<SuspenseFallback />}>
              <Outlet />
            </Suspense>
          </ReleaseFlagProvider>
        </UserProvider>
      </GuideTabProvider>
    </DeleteDialogProvider>
  );
}

export { AppContainer };
